// extracted by mini-css-extract-plugin
export var alert = "BentoBlock-module--alert--7b8e0";
export var cardsWithLinks = "BentoBlock-module--cardsWithLinks--c89f8";
export var fadeInAnimation = "BentoBlock-module--fadeInAnimation--5adc3";
export var layout = "BentoBlock-module--layout--748f1";
export var mobileWrapper = "BentoBlock-module--mobileWrapper--90715";